<div
  capraTooltip
  [tooltipContent]="attrTooltipHtml"
  [tooltipContentIsHtml]="true"
  [tooltipPlacement]="'left'"
  [tooltipInteractive]="true"
  [tooltipSize]="attrTooltipSize"
  [tooltipDelay]="[500, 0]"
  #attrContainer
  [class]="{ discrete: isDiscrete(), continuous: isContinuous(), 'is-invalid': isCalcFieldWithError() }"
  [contextMenu]="contextMenu"
  [contextMenuSubject]="attr"
  [dndDraggable]="true"
  [dndDisableIf]="!attr.isValid"
  dndEffectAllowed="all"
  (dndStart)="dragstart($event, attr)"
  (dndEnd)="dragend()"
  [attr.aria-label]="attrName"
  [attr.data-test]="dataTestName"
  *ngIf="attr"
>
  <capra-icon
    capraTooltip
    [tooltipContent]="errorHtml"
    [tooltipIsDisabled]="!isCalcFieldWithError()"
    [tooltipContentIsHtml]="true"
    [icon]="getFieldSvgIcon()"
  ></capra-icon>

  <div class="field-name">
    <span>{{ attrName }}</span>
    <capra-icon
      *ngIf="isLocalCalcField() && isExploreish()"
      capraTooltip
      tooltipContent="This field is local to the Exploration"
      icon="icon-local-field"
      data-test="icon-local-calc-field"
    ></capra-icon>
    <capra-icon
      *ngIf="isLocalCalcField() && isFromImportedDataset && !isExploreish()"
      capraTooltip
      tooltipContent="This field is local to the Report"
      icon="icon-local-field"
      data-test="icon-local-calc-field"
    ></capra-icon>
  </div>
  <ng-container *ngIf="hasContextMenu">
    <div class="field-info">
      <span class="context-menu-target" (click)="onContextMenu($event, attr)">
        <capra-icon icon="icon-caret-down"> </capra-icon>
      </span>
    </div>
  </ng-container>

  <context-menu [disabled]="!hasContextMenu" #contextMenu>
    <ng-container *ngIf="canModifyAttr">
      <ng-template contextMenuItem [enabled]="false" [passive]="true">
        <span class="context-heading-item">
          <span class="context-heading">Default settings</span>
        </span>
      </ng-template>
      <ng-container *ngIf="!hideFormatMenuOption">
        <ng-template contextMenuItem (execute)="openFormatModal()">
          <span class="context-link-name">Formatting</span>
        </ng-template>
      </ng-container>
      <ng-template
        contextMenuItem
        (execute)="openColorModal()"
        [enabled]="attr.isAggregateable || attr.isFormulaNumeric"
      >
        <span class="context-link-name">Color settings</span>
      </ng-template>
      <ng-container *ngIf="attr.isAggregateable">
        <ng-template contextMenuItem [divider]="true"></ng-template>
        <ng-container *ngIf="isDimension">
          <ng-container *ngFor="let aggOption of dimensionAggOptions">
            <ng-template contextMenuItem (execute)="setDefaultAggregate(aggOption.value)">
              <span [class.selected]="aggOption.value === defaultAgg">
                <span class="indicator"></span>
                <span class="context-link-name">{{ aggOption.label }}</span>
              </span>
            </ng-template>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="isMeasure">
          <ng-container *ngFor="let aggOption of measureAggOptions">
            <ng-template contextMenuItem (execute)="setDefaultAggregate(aggOption.value)">
              <span [class.selected]="aggOption.value === defaultAgg">
                <span class="indicator"></span>
                <span class="context-link-name">{{ aggOption.label }}</span>
              </span>
            </ng-template>
          </ng-container>
        </ng-container>
      </ng-container>
      <ng-template contextMenuItem [visible]="attr.isCalc" [divider]="true"></ng-template>
    </ng-container>

    <ng-template contextMenuItem [visible]="attr.isCalc" (execute)="viewCalc()">
      <span class="context-link-name">View formula...</span>
    </ng-template>
    <ng-template contextMenuItem [visible]="isLocalCalcField()" (execute)="editCalc()">
      <span class="context-link-name">Edit...</span>
    </ng-template>
    <ng-template contextMenuItem (execute)="duplicateCalc()">
      <span *ngIf="attr.isCalc" class="context-link-name"
        >{{ calcAttr?.isLocal ? 'Duplicate...' : 'Make local copy...' }}
      </span>
    </ng-template>
    <ng-template contextMenuItem [visible]="isLocalCalcField()" [divider]="true"></ng-template>
    <ng-template contextMenuItem [visible]="isLocalCalcField()" (execute)="removeCalc()">
      <span class="context-link-name">Delete</span>
    </ng-template>
  </context-menu>
</div>
